<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    offset-y
    bottom
    min-width="280"
    max-height="400"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        outlined
        small
        color="primary"
        v-bind="attrs"
        v-on="on"
        class="mr-2"
      >
        <v-icon left small>mdi-view-column</v-icon>
        Colonne
        <v-icon right small>mdi-chevron-down</v-icon>
      </v-btn>
    </template>

    <v-card class="column-selector">
      <v-card-title class="pb-2">
        <v-icon left>mdi-view-column</v-icon>
        Seleziona Colonne
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pa-2">
        <div class="d-flex justify-space-between mb-3">
          <v-btn
            text
            small
            color="primary"
            @click="selectAll"
          >
            <v-icon left small>mdi-checkbox-marked</v-icon>
            Seleziona tutto
          </v-btn>
          <v-btn
            text
            small
            color="grey"
            @click="deselectAll"
          >
            <v-icon left small>mdi-checkbox-blank-outline</v-icon>
            Deseleziona tutto
          </v-btn>
        </div>

        <v-divider class="mb-2"></v-divider>

        <div class="column-list">
          <v-checkbox
            v-for="column in columns"
            :key="column.key"
            v-model="selectedColumns"
            :value="column.key"
            dense
            hide-details
            class="ma-0 pa-1"
          >
            <template v-slot:label>
              <div class="d-flex align-center">
                <v-icon
                  left
                  small
                  :color="isSelected(column.key) ? 'primary' : 'grey'"
                >
                  {{ column.icon }}
                </v-icon>
                <span class="text-body-2">{{ column.label }}</span>
              </div>
            </template>
          </v-checkbox>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-3">
        <v-spacer></v-spacer>
        <v-chip
          small
          outlined
          color="primary"
          class="mr-2"
        >
          {{ selectedColumns.length }}/{{ columns.length }} colonne
        </v-chip>
        <v-btn
          text
          small
          @click="menu = false"
        >
          Chiudi
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'ColumnSelector',
  props: {
    columns: {
      type: Array,
      required: true,
      validator: (columns) => {
        return columns.every(col =>
          Object.prototype.hasOwnProperty.call(col, 'key') &&
          Object.prototype.hasOwnProperty.call(col, 'label') &&
          Object.prototype.hasOwnProperty.call(col, 'icon')
        );
      }
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      menu: false,
      selectedColumns: [...this.value]
    }
  },
  watch: {
    value: {
      handler(newValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(this.selectedColumns)) {
          this.selectedColumns = [...newValue];
        }
      },
      immediate: true,
      deep: true
    },
    selectedColumns: {
      handler(newValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(this.value)) {
          this.$emit('input', [...newValue]);
        }
      },
      deep: true
    }
  },
  methods: {
    isSelected(columnKey) {
      return this.selectedColumns.includes(columnKey);
    },
    selectAll() {
      this.selectedColumns = this.columns.map(col => col.key);
    },
    deselectAll() {
      this.selectedColumns = [];
    }
  }
}
</script>

<style scoped>
.column-selector {
  max-height: 500px;
  overflow-y: auto;
}

.column-list {
  max-height: 300px;
  overflow-y: auto;
}

.column-list .v-input--checkbox {
  margin: 0 !important;
  padding: 2px 0 !important;
}

.column-list .v-input--checkbox .v-input__slot {
  margin-bottom: 0 !important;
}

.column-list .v-input--checkbox:hover {
  background-color: rgba(92, 142, 214, 0.05);
  border-radius: 4px;
}

.v-card-title {
  font-size: 1rem !important;
  font-weight: 600;
}

.v-card-actions {
  background-color: rgba(0, 0, 0, 0.02);
}
</style>